/* eslint-disable */
import mixitup from 'mixitup';
import Swiper from 'swiper';

export default {
  init() {
    //  console.log('mixitup');
    $(window).load(() => {
      // const firstType = $(
      //   ".course-types-list .course-type-filter:first-child"
      // ).data("id");
      // console.log(firstType);
      // // Courses
      // mixitup(".courses-list-wrap", {
      //   selectors: {
      //     target: "div.course-item",
      //     control: ".course-type-filter",
      //   },
      //   animation: {
      //     duration: 0,
      //   },
      //   callbacks: {
      //     onMixEnd(state) {
      //       localStorage.setItem("courseType", state.activeFilter.selector);
      //     },
      //   },
      // }).filter(
      //   localStorage.getItem("courseType") || `.course-type-${firstType}`
      // );
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/pageTemplateTemplateCourses.js